module.exports = __webpack_public_path__ + "b7820bd559337542030f997069b301c5.svg";